import { all } from 'redux-saga/effects';

import loading from './loading';
import user from './user';
import location from './location';

// @generator sagas:import

export default function * root() {
  yield all([
    ...loading,
    ...user,
    ...location,
    // @generator sagas:export
  ]);
}
